import type { SharedFormatMessage } from "@akina/infra";
import { Text, Headline, SideContentLayout } from "../components";

export const OfflinePage = ({ formatMessage }: { formatMessage: SharedFormatMessage }) => {
  return (
    <SideContentLayout>
      <div className="my-2 flex h-18 items-center gap-4 rounded-full bg-primary-100 px-7 py-4">
        <div className="h-5 w-5 rounded-full bg-white" />
        <Text fontWeight="font-extrabold" className="mr-1 text-[20px] text-white">
          {formatMessage({ id: "shared.pages.offline.statusBanner" })}
        </Text>
      </div>
      <Headline fontWeight="font-bold" size="3xl">
        {formatMessage({ id: "shared.pages.offline.title" })}
      </Headline>
      <Text className="text-lg leading-[32px] text-gray-800/70">
        {formatMessage({ id: "shared.pages.offline.description" })}
      </Text>
    </SideContentLayout>
  );
};
